module.exports = __webpack_public_path__ + "static/media/tip_goal_with_white_bg.b1985dbf.svg";